import './SummaryBreakout.css';
import Item from './Item';
import { FormattedValue } from './financialsModel';

export type Props = {
  title: string
  amounts: FormattedValue[]
  type: string
}
export default function SummaryBreakout({ title, amounts, type }: Props) {
  const items = amounts.map(({ title, amount, style }, index) => {
    return <div key={index} className="financial-summary-breakout-item"><Item title={title} amount={amount} type={type} style={style} /></div>
  })

  return (
    <div className={"financial-summary-breakout financial-summary-breakout-" + type}>
      <h1>
        {title}
      </h1>
      <div className={"financial-summary-breakout-body financial-summary-breakout-body-" + type}>
        {items}
      </div>
    </div>
  );
}
